/**
 * API Service for InternalK1Hierarchy
 */

import { makeCygnusApiCall } from "api/api";

/**
 * @param {string} returnId - The ID of the client to fetch data for.
 * Fetches the hierarchy of clients returns.
 */
export const getHierarchy = async (returnId: any, clientMasterId: string | null | undefined): Promise<any[]> => {
  const hierarchy = await makeCygnusApiCall({
    type: "GET",
    payload: {},
    url: `/client/hierarchy/${clientMasterId}/`,
    show_message: false,
    customized_success_message: "Fetched Data Successfully",
    customized_failure_message: "Unable to fetch data, please contact support and attach a screenshot.",
    isblob: false,
    path: "/tax",
    istax: true
  });
  return hierarchy?.data ?? [];
}